'use client'

import { memo } from 'react'
import { UsersIcon, MagnifyingGlassIcon, PlusIcon } from '@phosphor-icons/react'
import { AddPersonDialog } from './add-person-dialog'
import { Button } from '@/ui/button'

export const EmptyState = memo(function EmptyState({
  searchQuery,
}: {
  searchQuery: string
}) {
  if (searchQuery) {
    return (
      <div className="flex items-start gap-4 py-8">
        <div className="bg-muted/50 flex h-10 w-10 shrink-0 items-center justify-center rounded-full">
          <MagnifyingGlassIcon className="text-muted-foreground h-5 w-5" />
        </div>
        <div>
          <p className="text-foreground text-sm font-medium">
            No matches for &quot;{searchQuery}&quot;
          </p>
          <p className="text-muted-foreground mt-1 text-xs">
            Try a different search or check your spelling
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="flex items-start gap-4 py-8">
      <div className="bg-muted/50 flex h-10 w-10 shrink-0 items-center justify-center rounded-full">
        <UsersIcon className="text-muted-foreground h-5 w-5" />
      </div>
      <div>
        <p className="text-foreground text-sm font-medium">
          No people in your network
        </p>
        <p className="text-muted-foreground mt-1 max-w-xs text-xs">
          Add someone to track interactions, or tag them in journal entries and
          tasks
        </p>
        <AddPersonDialog
          trigger={
            <Button variant="outline" size="sm" className="mt-3 gap-1.5">
              <PlusIcon className="h-3.5 w-3.5" weight="bold" />
              Add person
            </Button>
          }
        />
      </div>
    </div>
  )
})
